var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.73,19a2.13,2.13,0,0,0-.73-.73V14.5H13V12.73A2,2,0,0,0,12,9a1.81,1.81,0,0,0-.52.07L7.93,5.52A1.81,1.81,0,0,0,8,5,2,2,0,0,0,7,3.27V2H5V3.27A2,2,0,0,0,6,7a1.81,1.81,0,0,0,.52-.07l3.55,3.55A1.81,1.81,0,0,0,10,11a2,2,0,0,0,1,1.73V16.5h4v1.77A2,2,0,1,0,17.73,21H19V19ZM6,6A1,1,0,1,1,7,5,1,1,0,0,1,6,6Zm6,6a1,1,0,1,1,1-1A1,1,0,0,1,12,12Zm4,9a1,1,0,1,1,1-1A1,1,0,0,1,16,21Z",
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.b8991316dd12374b82bac163a1a492d6.svg";
export { ForwardRef as ReactComponent };